import { Text, makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  row: { display: "inline-flex", alignItems: "center", gap: "8px", color: "inherit" },
  img: { display: "block", flexShrink: 0 },
});

/**
 * Icon + text, for coloured/dark surfaces such as the app header (text inherits colour).
 * `size` is the icon height in px.
 */
export function Logo({ size = 24, color }: { size?: number; color?: string }) {
  const s = useStyles();
  return (
    <span className={s.row}>
      <img src="/icon-192.png" alt="" width={size} height={size} className={s.img} />
      <Text weight="semibold" style={{ fontSize: Math.round(size * 0.85), lineHeight: 1, color: color ?? tokens.colorBrandForeground1 }}>
        RackUp
      </Text>
    </span>
  );
}

/** The full wordmark artwork — for white pages (sign-in, join, legal, client portal). `height` in px. */
const WORDMARK_RATIO = 1904 / 472; // source artwork width / height

export function Wordmark({ height = 44 }: { height?: number }) {
  const width = Math.round(height * WORDMARK_RATIO);
  const style = { display: "block", width, height, maxWidth: "100%", objectFit: "contain" as const, objectPosition: "left", alignSelf: "flex-start", flex: "0 0 auto" };
  // Navy text is unreadable on dark backgrounds; the dark variant has white text, same icon.
  return (
    <picture style={{ display: "block", width, height, maxWidth: "100%", flex: "0 0 auto", alignSelf: "flex-start" }}>
      <source srcSet="/wordmark-dark-sm.png" media="(prefers-color-scheme: dark)" />
      <img src="/wordmark-sm.png" alt="RackUp" width={width} height={height} style={style} />
    </picture>
  );
}
